import React from 'react'

function FooterText() {
  return (
    <div className="btm-content">
    <span>
      We use cookies.{" "}
      <a href="https://www.idfcfirstbank.com/privacy-policy">
        Click here
      </a>{" "}
      to see our policy.
    </span>
    <span>
      {/* <a href="https://www.idfcfirstbank.com/privacy-policy">Get Help</a>{" "} */}
    </span>
    <span>Copyright© 2024 IDFC FIRST Bank Ltd. All Rights Reserved</span>
  </div>
  )
}

export default FooterText
